import { render, staticRenderFns } from "./GarbageRemovalCategory.vue?vue&type=template&id=6f9fcbd0&"
import script from "./GarbageRemovalCategory.vue?vue&type=script&lang=js&"
export * from "./GarbageRemovalCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports